import http from './http-common';
class ModelService {
  
    getModels() {
        return http.get('/custom-speech/models');
    }

    getEndpoints() {
        return http.get('/custom-speech/endpoints');
    }

    getModelsProject() {
        return http.get('/custom-speech/models/projects');
    }

    updateModels(userId, modelIds) {
        return http.post(`/custom-speech/models/associate`, { userId,modelIds });
    }
    updateEndpoints(userId, endpointsIds) {
        return http.post(`/custom-speech/endpoints/associate`, { userId,endpointsIds });
    }

    
}

export default new ModelService();
